import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Pets from './pages/Pets';
import Subscriptions from './pages/Subscriptions';
import Orders from './pages/Orders';
import Profile from './pages/Profile';
import Points from './pages/Points';
import Referrals from './pages/Referrals';
import Affiliate from './pages/Affiliate';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Affiliate dashboard - standalone without layout/menu (for embedding in Shopify) */}
        <Route path="/affiliate" element={<Affiliate />} />
        <Route path="/m/:merchantId/affiliate" element={<Affiliate />} />

        {/* Support both /m/merchantname/* and direct /* paths */}
        <Route path="/m/:merchantId" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="pets" element={<Pets />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="orders" element={<Orders />} />
          <Route path="points" element={<Points />} />
          <Route path="referrals" element={<Referrals />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* Root paths for production (merchantname.aiva.nz) */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="pets" element={<Pets />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="orders" element={<Orders />} />
          <Route path="points" element={<Points />} />
          <Route path="referrals" element={<Referrals />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
